import React from 'react';
import { useAlert } from './AlertContext';
import './AlertSystem.css';

const AlertContainer = () => {
  const { toasts, confirmData, setToasts } = useAlert();

  const getIcon = (type) => {
    switch (type) {
      case 'success': return 'fa-solid fa-circle-check';
      case 'error': return 'fa-solid fa-circle-xmark';
      case 'warning': return 'fa-solid fa-triangle-exclamation';
      default: return 'fa-solid fa-circle-info';
    }
  };

  const getConfirmIcon = (type) => {
    switch (type) {
      case 'danger': return 'fa-solid fa-trash-can';
      case 'warning': return 'fa-solid fa-circle-question';
      default: return 'fa-solid fa-circle-info';
    }
  };

  return (
    <>
      {/* Toasts Stack */}
      <div className="toast-container">
        {toasts.map((toast) => (
          <div key={toast.id} className={`premium-toast ${toast.type}`}>
            <div className="toast-icon">
              <i className={getIcon(toast.type)}></i>
            </div>
            <div className="toast-content">
              <p className="toast-message">{toast.message}</p>
            </div>
            <button 
              className="toast-close"
              onClick={() => setToasts(prev => prev.filter(t => t.id !== toast.id))}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        ))}
      </div>

      {/* Confirmation Modal */}
      {confirmData && (
        <div className="confirm-overlay">
          <div className="confirm-modal">
            <div className="confirm-icon">
              <i className={getConfirmIcon(confirmData.type)}></i>
            </div>
            <h3>{confirmData.title}</h3>
            <p>{confirmData.message}</p>
            <div className="confirm-actions">
              <button className="btn-confirm secondary" onClick={confirmData.onCancel}>
                {confirmData.cancelText}
              </button>
              <button className="btn-confirm primary" onClick={confirmData.onConfirm}>
                {confirmData.confirmText}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AlertContainer;
